import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import type { Breakpoint } from '@mui/material/styles';

import type { CardSize } from '../types/card-size.type';

const GRID_COLUMNS = 12;
const BREAKPOINTS_UP: readonly Breakpoint[] = ['xl', 'lg', 'md', 'sm', 'xs'];

// The cards per row at the current width: the size of the widest breakpoint reached.
export const useColumnCount = (size: CardSize): number => {
  const { breakpoints } = useTheme();
  const reached: Readonly<Record<Breakpoint, boolean>> = {
    xl: useMediaQuery(breakpoints.up('xl')),
    lg: useMediaQuery(breakpoints.up('lg')),
    md: useMediaQuery(breakpoints.up('md')),
    sm: useMediaQuery(breakpoints.up('sm')),
    xs: true,
  };
  const breakpoint = BREAKPOINTS_UP.find(
    (candidate) => reached[candidate] && size[candidate] !== undefined,
  );
  const cardColumns = breakpoint
    ? (size[breakpoint] ?? GRID_COLUMNS)
    : GRID_COLUMNS;

  return Math.max(1, Math.floor(GRID_COLUMNS / cardColumns));
};
